/* Cloudflare Turnstile durumu (section'daki data-*-callback'ler buraya düşer).
   Token hazır olmadan submit edilirse handleRegister kısa süre bekler; süresi dolan
   token otomatik yenilenir; challenge hatasında widget resetlenip yeniden denenir. */
window.bbTurnstile = window.bbTurnstile || { token: '', error: null };
window.bbWarrantyTurnstileOk = function (token) { window.bbTurnstile.token = token || ''; window.bbTurnstile.error = null; };
window.bbWarrantyTurnstileExpired = function () { window.bbTurnstile.token = ''; };
window.bbWarrantyTurnstileError = function (code) { window.bbTurnstile.token = ''; window.bbTurnstile.error = code || 'error'; };

class WarrantyFormHandler {
    constructor() {
        this.warrantyApiUrl = 'https://portal.babybrezza.com/api/warranty/activate';
        this.listrakApiUrl = 'https://optin.babybrezza.com/api/subscribe/listrak';
        this.klaviyoApiUrl = 'https://optin.babybrezza.com/api/subscribe/klaviyo';
        this.reviewApiUrl = 'https://portal.babybrezza.com/api/review';

        this.registerWrapper = document.querySelector(".warranty-main-form-wrapper");
        this.reviewWrapper = document.querySelector(".submit-review");
        this.successWrapper = document.querySelector(".successful-review-submission-container");
        this.noThanksWrapper = document.querySelector(".no-thanks-review-exit");

        this.registerForm = document.querySelector(".register-product-form");
        this.reviewForm = document.querySelector(".submit-review-form");
        this.noThanksBtn = document.querySelector("#noThanks");

        this.categoryCards = document.querySelectorAll(".category-selection-card");
        this.productCards = document.querySelectorAll(".product-selection-card");
        this.productSection = document.getElementById("productCardSection");

        this.website = document.getElementById("website");
        this.userInfo = document.getElementById("userInfo");

        this.productInputName = document.getElementById("selectedProductName");
        this.productInputID = document.getElementById("selectedProductID");
        this.productInputURL = document.getElementById("selectedProductURL");

        this.acceptanceCheckbox = document.getElementById("acceptance");

        this.init();

        const translationEl = document.getElementById("translations-warranty-form");

        this.translations = {
            captchaError: translationEl?.dataset.captchaError,
            invalidEmail: translationEl?.dataset.invalidEmail,
            productError: translationEl?.dataset.productError,
            registrationFailed: translationEl?.dataset.registrationFailed,
            registrationSuccess: translationEl?.dataset.registrationSuccess,
            serverError: translationEl?.dataset.serverError,
            reviewFailed: translationEl?.dataset.reviewFailed,
            reviewSuccess: translationEl?.dataset.reviewSuccess
        };
    }

    init() {
        this.bindCategorySelection();
        this.bindProductSelection();
        this.registerForm?.addEventListener("submit", e => this.handleRegister(e));
        this.reviewForm?.addEventListener("submit", e => this.handleReview(e));
        this.noThanksBtn?.addEventListener("click", e => this.handleNoThanks(e));
    }

    /* Turnstile token'ını form içinden oku; yoksa challenge'ı (yeniden) çalıştırıp
       en fazla ~10 sn bekle. Böylece kullanıcı formu doldururken token'ın süresi
       dolduysa ya da challenge henüz bitmediyse hemen hata gösterilmez. */
    async getTurnstileToken(form) {
        const read = () => {
            const input = form.querySelector('[name="cf-turnstile-response"]');
            return (input && input.value) || window.bbTurnstile?.token || '';
        };
        let token = read();
        if (token) return token;

        const widget = form.querySelector('.cf-turnstile');
        if (window.turnstile && widget) {
            try { window.turnstile.reset(widget); } catch (err) { /* widget henüz render olmadıysa yoksay */ }
        }
        const submitBtn = form.querySelector('.warranty-submit-button');
        if (submitBtn) submitBtn.disabled = true;
        const started = Date.now();
        while (Date.now() - started < 10000) {
            await new Promise(r => setTimeout(r, 250));
            token = read();
            if (token) break;
            if (window.bbTurnstile?.error) break; // challenge başarısız — beklemeye gerek yok
        }
        if (submitBtn) submitBtn.disabled = false;
        return token;
    }

    /* ===============================
       STRONG EMAIL VALIDATION
    =============================== */
    isValidEmail(email) {
        if (!email || email.length > 254) return false;

        // ASCII only (emoji, unicode yok)
        if (!/^[\x00-\x7F]+$/.test(email)) return false;

        const [local, domain] = email.split("@");
        if (!local || !domain) return false;

        // Local-part rules
        if (
            local.length < 2 ||
            local.length > 64 ||
            local.startsWith(".") ||
            local.endsWith(".") ||
            local.includes("..")
        ) return false;

        // Domain rules
        if (
            domain.length < 4 ||
            domain.includes("..") ||
            !domain.includes(".")
        ) return false;

        const tld = domain.split(".").pop();
        if (!tld || tld.length < 2 || tld.length > 24) return false;

        // RFC-safe regex (strict)
        const strictRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,24})+$/;
        return strictRegex.test(email);
    }

    bindCategorySelection() {
        this.categoryCards.forEach(card => {
            card.addEventListener("click", () => {
                this.categoryCards.forEach(c => c.classList.remove("is-selected"));
                card.classList.add("is-selected");

                const category = card.dataset.categoryName;
                this.productSection.style.opacity = "1";
                this.productSection.style.pointerEvents = "auto";

                this.productCards.forEach(p => {
                    p.style.display = p.dataset.parentCategory === category ? "flex" : "none";
                    p.classList.remove("is-selected");
                });

                this.productInputID.value = "";
                this.productInputName.value = "";
                this.productInputURL.value = "";
            });
        });
    }

    bindProductSelection() {
        this.productCards.forEach(card => {
            card.addEventListener("click", () => {
                this.productCards.forEach(p => p.classList.remove("is-selected"));
                card.classList.add("is-selected");

                this.productInputID.value = card.dataset.productId;
                this.productInputName.value = card.dataset.productName;
                this.productInputURL.value = card.dataset.productUrl;
            });
        });
    }

    async handleRegister(e) {
        e.preventDefault();

        const captcha = await this.getTurnstileToken(e.target);
        if (!captcha) {
            showToast(this.translations.captchaError, "error");
            return;
        }

        const formData = new FormData(e.target);
        const email = formData.get("email")?.trim();
        const firstName = formData.get("first_name");
        const lastName = formData.get("last_name");

        if (!this.isValidEmail(email)) {
            showToast(this.translations.invalidEmail, "error");
            return;
        }

        if (!this.productInputID.value) {
            showToast(this.translations.productError, "error");
            return;
        }

        const payload = {
            email,
            first: firstName,
            last: lastName,
            product: this.productInputName.value,
            productId: this.productInputID.value,
            website: this.website.value,
            // Portal VIP bayrağını `vsta` (boolean) olarak bekliyor; is_vip geriye dönük uyumluluk için kalıyor.
            vsta: this.userInfo?.value === 'true',
            is_vip: this.userInfo?.value === 'true',
            opt_in: formData.get("is_subscribed") === "on",
            captchaToken: captcha
        };

        try {
            const res = await fetch(this.warrantyApiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            if (!res.ok) {
                showToast(result.message || this.translations.registrationFailed, "error");
                return;
            }

            if (this.acceptanceCheckbox?.checked) {
                const finalLink = this.website.value === 'US'
                    ? this.listrakApiUrl
                    : this.klaviyoApiUrl;

                fetch(finalLink, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email, firstName, lastName, website: this.website.value })
                }).catch(() => {});
            }

            showToast(this.translations.registrationSuccess, "success");
            this.registerWrapper.style.display = "none";
            this.reviewWrapper.style.display = "block";

        } catch {
            showToast(this.translations.serverError, "error");
        }
    }

    async handleReview(e) {
        e.preventDefault();

        const reviewFormData = new FormData(e.target);
        const params = new URLSearchParams({
            website: this.website.value,
            sku: this.productInputID.value,
            product_title: this.productInputName.value,
            product_url: this.productInputURL.value,
            display_name: `${this.registerForm.querySelector('[name="first_name"]').value} ${this.registerForm.querySelector('[name="last_name"]').value}`,
            email: this.registerForm.querySelector('[name="email"]').value,
            review_content: reviewFormData.get("detail"),
            review_title: reviewFormData.get("title"),
            review_score: reviewFormData.get("rating")
        });

        const res = await fetch(this.reviewApiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: params.toString()
        });

        if (!res.ok) {
            showToast(this.translations.reviewFailed, "error");
            return;
        }

        showToast(this.translations.reviewSuccess, "success");
        this.reviewWrapper.style.display = "none";
        this.successWrapper.style.display = "flex";
    }

    handleNoThanks(e) {
        e.preventDefault();
        this.reviewWrapper.style.display = "none";
        this.noThanksWrapper.style.display = "flex";
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new WarrantyFormHandler();
});
